// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.portrait_frame__pwfg6 {
  position: relative;
  width: 100%;
  overflow: hidden;
  background: var(--color-cloud);
  isolation: isolate;
}
.portrait_arch__1ZyG\\+ {
  border-radius: 999px 999px var(--radius-md) var(--radius-md);
}
.portrait_tall__ytrJv {
  border-radius: 0 var(--radius-lg) 0 var(--radius-lg);
}
.portrait_circle__LQ0rg {
  border-radius: 50%;
}
.portrait_placed__PQHWa,
.portrait_fallback__a2IR8 {
  display: block;
  filter: grayscale(1) contrast(1.04);
  /* white studio backgrounds take on the frame colour, so every card matches */
  mix-blend-mode: multiply;
  transition: transform 0.8s var(--ease-out);
}
.portrait_placed__PQHWa {
  position: absolute;
  height: auto;
  max-width: none;
}
.portrait_fallback__a2IR8 {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center 20%;
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/PORTRAIT/portrait.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,4DAA4D;AAC9D;AACA;EACE,oDAAoD;AACtD;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,cAAc;EACd,mCAAmC;EACnC,6EAA6E;EAC7E,wBAAwB;EACxB,0CAA0C;AAC5C;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;AAC7B","sourcesContent":[".frame {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  background: var(--color-cloud);\n  isolation: isolate;\n}\n.arch {\n  border-radius: 999px 999px var(--radius-md) var(--radius-md);\n}\n.tall {\n  border-radius: 0 var(--radius-lg) 0 var(--radius-lg);\n}\n.circle {\n  border-radius: 50%;\n}\n.placed,\n.fallback {\n  display: block;\n  filter: grayscale(1) contrast(1.04);\n  /* white studio backgrounds take on the frame colour, so every card matches */\n  mix-blend-mode: multiply;\n  transition: transform 0.8s var(--ease-out);\n}\n.placed {\n  position: absolute;\n  height: auto;\n  max-width: none;\n}\n.fallback {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center 20%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"frame": `portrait_frame__pwfg6`,
	"arch": `portrait_arch__1ZyG+`,
	"tall": `portrait_tall__ytrJv`,
	"circle": `portrait_circle__LQ0rg`,
	"placed": `portrait_placed__PQHWa`,
	"fallback": `portrait_fallback__a2IR8`
};
export default ___CSS_LOADER_EXPORT___;
